import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import NotifyModal from 'components/NotifyModal';
import { DIALOG_KINDS } from 'constants/dialogKinds';
import { LicensesContext, actionTypes } from '../../licensesContext';

const EditAssignmentWarningModal = ({ onConfirm, numOfLicenseRemovals }) => {
  const {
    dispatch,
    licensesState: { tenRemovalsModalOpen },
  } = useContext(LicensesContext);

  const closeModal = () => {
    dispatch({
      type: actionTypes.TOGGLE_TEN_REMOVALS_MODAL,
    });
  };

  const closeModalImmediatelyOnClick = () => {
    closeModal();
    onConfirm();
  };

  return (
    <NotifyModal
      mode={DIALOG_KINDS.ERROR}
      onCancel={closeModal}
      onConfirm={closeModalImmediatelyOnClick}
      open={tenRemovalsModalOpen}
      title="Remove licenses"
      cancelText="Cancel"
      confirmText="Remove licenses"
    >
      <div className="m-notify-modal">
        This action will remove licenses for {numOfLicenseRemovals} users. These
        users will no longer be able to use licensed features.
      </div>
    </NotifyModal>
  );
};

EditAssignmentWarningModal.propTypes = {
  numOfLicenseRemovals: PropTypes.number.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default EditAssignmentWarningModal;
